import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import "./UserManagementMaster.css";

class ClientContactUserDetail extends React.Component {
  componentDidUpdate() {
    window.onpopstate = () => {
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.props.history.push("/Home/Management/Users/ClientContacts");
    };
  }

  ShowSidePanel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Users/ClientContacts");
  };

  getRoleLabel(role, t) {
    const normalized = (role || "").toLowerCase();
    if (role === "FM" || normalized === "fleetmanager") {
      return t("ClientContactUserManagementContent.FM");
    }
    if (role === "TSI" || normalized === "superintendent") {
      return t("ClientContactUserManagementContent.TSI");
    }
    if (role === "TE" || normalized === "technicalexecutive") {
      return t("ClientContactUserManagementContent.TE");
    }
    return role;
  }

  renderDetailField(label, value, iconClass) {
    return (
      <div className="col-lg-6 col-md-6 mb-3 um-detail-field">
        <label className="form-label">{label}</label>
        <div className="um-input-shell">
          <span className="um-input-icon">
            <i className={`fa ${iconClass}`} aria-hidden="true"></i>
          </span>
          <input
            className="form-control"
            type="text"
            value={value || ""}
            readOnly
          />
        </div>
      </div>
    );
  }

  render() {
    const { ClientContactUserDetails, t } = this.props;
    const user = ClientContactUserDetails || {};

    return (
      <div className="full-height user-module-master um-detail">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue um-return-btn"
                onClick={this.ShowSidePanel}
                style={{ display: "inline-flex", alignItems: "center" }}
              >
                <span style={{ marginTop: "-1px" }}>&larr;</span>
                {t("CommonText.Return")}
              </button>

              <div className="um-section">
                <div className="um-section-header">
                  <h5 className="um-section-title">
                    {t("ClientContactUserManagementContent.UserDetails")}
                  </h5>
                </div>
                <div className="um-section-body">
                  <div className="row">
                    {this.renderDetailField(
                      t("EquipmentManagementScreenContent.Name"),
                      user.name,
                      "fa-user-circle"
                    )}
                    {this.renderDetailField(
                      t("ServicedByScreenContent.Email"),
                      user.email,
                      "fa-envelope-o"
                    )}
                    {this.renderDetailField(
                      t("ClientManagementScreenContent.Phone"),
                      user.phone,
                      "fa-phone"
                    )}
                    {this.renderDetailField(
                      t("ClientContactUserManagementContent.Role"),
                      this.getRoleLabel(user.role || user.userType, t),
                      "fa-briefcase"
                    )}
                    {this.renderDetailField(
                      t("ClientContactUserManagementContent.ClientName"),
                      user.clientName,
                      "fa-building"
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    ClientContactUserDetails:
      state.MasterScreenReducer.ClientContactUserDetails,
  };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientContactUserDetail))
);
